import React, { useRef } from 'react';
import { isEqual } from 'lodash';
import styled from 'styled-components';
import { getSimpleContext } from '../_utils/simple';

const FormDiv = styled.div`
  color: #222;
  .v-field {
    //margin: 24px 0;
    margin-top: 24px;
    display: flex;
    &.files {
      p {
        margin-top: 10px;
      }
      p:first-child {
        margin-top: 0;
      }
    }

    .v-label {
      font-weight: 500;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #222222;
      margin-right: 34px;
      width: 120px;
      min-width: 120px;
      text-align: right;
    }
    .v-value {
      font-weight: 400;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #222222;
      text-align: left;
      width: 100%;
    }
    &.row {
      flex-direction: column;
      .v-label {
        margin-bottom: 12px;
        text-align: left;
        width: 100%;
      }
      .v-value {
        width: 100%;
      }
    }
  }
  .roo-icon-file {
    height: 20px;
    width: 20px;
    font-size: 20px;
    color: rgb(25, 140, 255);
    margin-right: 8px;
    position: relative;
    top: -3px;
  }
  .text-line {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 300px;
    margin-right: 10px;
  }
`;

const { useSimpleContext, Provider } = getSimpleContext({
  values: {},
  valuesRef: React.createRef(),
  update:1
});

export const useViewContext = useSimpleContext;
export const FormViewProvider = Provider;

export function FormView(props) {
  const { onChange, handleSave, children } = props;
  const { state } = useViewContext((t) => [t.valuesRef]);
  state.valuesRef.current = props.value;

  return <FormDiv>{props.children}</FormDiv>;
}
